import { Box, Button, Card, CardContent, Checkbox, FormControlLabel, FormGroup, Input, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@material-ui/core';
import { AFORMA_PDV_SISARE_MULTI, AGENERO_SERVICO_AEREO, AGENERO_SERVICO_CRUZEIRO, AGENERO_SERVICO_HOSPEDAGEM, AGENERO_SERVICO_LOCADORAVEICULOS, AGENERO_SERVICO_OPCIONAL, AGENERO_SERVICO_OUTROS, AGENERO_SERVICO_OUTROSVIAGENS, AGENERO_SERVICO_PACOTEVIAGENS, AGENERO_SERVICO_SEGUROVIAGEM, AGENERO_SERVICO_SERVICOVIAGENS, AGENERO_SERVICO_TRANSPORTE, ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import PerfectScrollbar from 'react-perfect-scrollbar';
import api from '../../../services/api';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import SearchCidade from 'views/Components/SearchCidade';
import ComboPadraoMultiple from 'views/Components/ComboPadraoMultiple';
import { getConfigField, loadCompany } from 'lib/configUtils';

class ServicoList extends Component {
    state = {
        servicos: [],
        searchFilter: {
            nomeServico: '',
            abreviatura: '',
            codServico: '',
            situacaoInativoFilter: ANAO,
            generosReceptivo: [],
            generosAgencia: [],
            afinidades: [],
            codcidadeservico: '',
            somenteServPDVMovel: false,
            pdvs: []
        },
        listaGeneroReceptivo: [],
        listaGeneroAgencia: [],
        listaAfinidades: [],
        listaPdvs: [],
        page: 0, // Página atual
        rowsPerPage: 50, // Número de itens por página
        totalItems: 0, // Total de itens para paginação
    };

    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right', // alinhamento a direita
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red',
        },
    };

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        let {
            searchFilter,
            listaGeneroReceptivo,
            listaGeneroAgencia,
            listaAfinidades,
            listaPdvs
        } = this.state;

        const vendehospedagem = (getConfigField('vendehospedagem') == ASIM);
        const vendeaereo = (getConfigField('vendeaereo') == ASIM);
        const vendetransporte = (getConfigField('vendetransporte') == ASIM);
        const vendeopcionais = (getConfigField('vendeopcionais') == ASIM);
        const vendeseguroviagem = (getConfigField('vendeseguroviagem') == ASIM);
        const vendelocadoraveiculos = (getConfigField('vendelocadoraveiculos') == ASIM);
        const vendecruzeiros = (getConfigField('vendecruzeiros') == ASIM);
        const vendeservicosviagens = (getConfigField('vendeservicosviagens') == ASIM);
        const vendepacotesviagens = (getConfigField('vendepacotesviagens') == ASIM);
        const vendeoutrosviagens = (getConfigField('vendeoutrosviagens') == ASIM);

        const multipdv = (getConfigField('formapdv') == AFORMA_PDV_SISARE_MULTI);

        const codPDV = sessionStorage.getItem('codPDV');

        /* */
        if (vendeopcionais) {
            listaGeneroReceptivo.push({ id: "Opcionais", item: "Opcionais" });
        }

        if (vendetransporte) {
            listaGeneroReceptivo.push({ id: "Transporte", item: "Transporte" });
            listaGeneroReceptivo.push({ id: "IN", item: "IN" });
            listaGeneroReceptivo.push({ id: "OUT", item: "OUT" });
        }

        listaGeneroReceptivo.push({ id: "Outros", item: "Outros" });

        searchFilter.generosReceptivo = listaGeneroReceptivo;

        /* */
        if (vendehospedagem) {
            listaGeneroAgencia.push({ id: "Hospedagem", item: "Hospedagem" });
        }
        if (vendeaereo) {
            listaGeneroAgencia.push({ id: "Aéreo", item: "Aéreo" });
        }
        if (vendeseguroviagem) {
            listaGeneroAgencia.push({ id: "Seguro viagem", item: "Seguro viagem" });
        }
        if (vendepacotesviagens) {
            listaGeneroAgencia.push({ id: "Pacotes", item: "Pacotes" });
        }
        if (vendelocadoraveiculos) {
            listaGeneroAgencia.push({ id: "Locação de veículos", item: "Locação de veículos" });
        }
        if (vendecruzeiros) {
            listaGeneroAgencia.push({ id: "Cruzeiros", item: "Cruzeiros" });
        }
        if (vendeservicosviagens) {
            listaGeneroAgencia.push({ id: "Serviços", item: "Serviços" });
        }
        if (vendeoutrosviagens) {
            listaGeneroAgencia.push({ id: "Outros", item: "Outros" });
        }

        searchFilter.generosAgencia = listaGeneroAgencia;

        /* */
        const afinidadesservico = await api.get(`/afinidadeservico/active/true`);
        {
            afinidadesservico.data.map((afinidade) => (
                listaAfinidades.push({ id: afinidade.id, item: afinidade.descafinidade })
            ))
        };

        /* */
        if (multipdv) {
            const pdvsservico = await api.get(`/pdv/active/true`);
            {
                pdvsservico.data.map((pdv) => (
                    listaPdvs.push({ id: pdv.codpdvconfig, item: pdv.descpdv })
                    // ((pdv.codpdvconfig == codPDV) ? searchFilter.pdvs.push({ id: pdv.codpdvconfig, item: pdv.descpdv }) : null)
                ))
            }

            searchFilter.pdvs = listaPdvs.filter(item => item.id == codPDV);
        }

        /* */
        this.setState({
            searchFilter: searchFilter,
            listaGeneroReceptivo: listaGeneroReceptivo,
            listaGeneroAgencia: listaGeneroAgencia,
            listaAfinidades: listaAfinidades,
            listaPdvs: listaPdvs
        });

        this.loadServicos();
    }

    /* Carrega Serviços */
    loadServicos = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;

        const multipdv = (getConfigField('formapdv') == AFORMA_PDV_SISARE_MULTI);

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        /* consulta pela descrição do serviço */
        if (!(searchFilter.nomeServico === '')) {
            params += '&tbservico.descservico=_like_' + searchFilter.nomeServico
        }

        /* consulta pela abreviatura do serviço */
        if (!(searchFilter.abreviatura === '')) {
            params += '&tbservico.abreviatura=_like_' + searchFilter.abreviatura
        }

        /* consulta pelo código do serviço */
        if (!(searchFilter.codServico === '')) {
            params += '&tbservico.codservico=' + searchFilter.codServico
        }

        /* filtra situação do serviço */
        switch (searchFilter.situacaoInativoFilter) {
            case ASIM:
                params += '&tbservico.inativo=' + ASIM
                break;
            case ANAO:
                params += '&tbservico.inativo=' + ANAO
                break;
            default:
                break;
        }

        let generosServico = '';
        /* filtra gênero do serviço */
        if (searchFilter.generosReceptivo.length > 0) {
            if (searchFilter.generosReceptivo.map(item => item.id).includes("Opcionais")) {
                generosServico += AGENERO_SERVICO_OPCIONAL + ',';
            }
            if (searchFilter.generosReceptivo.map(item => item.id).includes("Transporte")) {
                generosServico += AGENERO_SERVICO_TRANSPORTE + ',';

                if (!(searchFilter.generosReceptivo.map(item => item.id).includes("IN"))) {
                    params += '&tbservico.transferin=' + ANAO;
                }
                if (!(searchFilter.generosReceptivo.map(item => item.id).includes("OUT"))) {
                    params += '&tbservico.transferout=' + ANAO;
                }
            }
            if (searchFilter.generosReceptivo.map(item => item.id).includes("Outros")) {
                generosServico += AGENERO_SERVICO_OUTROS + ',';
            }
        }

        if (searchFilter.generosAgencia.length > 0) {
            if (searchFilter.generosAgencia.map(item => item.id).includes("Hospedagem")) {
                generosServico += AGENERO_SERVICO_HOSPEDAGEM + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Aéreo")) {
                generosServico += AGENERO_SERVICO_AEREO + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Seguro viagem")) {
                generosServico += AGENERO_SERVICO_SEGUROVIAGEM + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Pacotes")) {
                generosServico += AGENERO_SERVICO_PACOTEVIAGENS + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Locação de veículos")) {
                generosServico += AGENERO_SERVICO_LOCADORAVEICULOS + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Cruzeiros")) {
                generosServico += AGENERO_SERVICO_CRUZEIRO + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Serviços")) {
                generosServico += AGENERO_SERVICO_SERVICOVIAGENS + ',';
            }
            if (searchFilter.generosAgencia.map(item => item.id).includes("Outros")) {
                generosServico += AGENERO_SERVICO_OUTROSVIAGENS + ',';
            }
        }

        if (!(generosServico == '')) {
            generosServico = generosServico.slice(0, -1);
            params += '&tbservico.codigogenero=_in_' + generosServico;
        }

        /* filtro pela afinidade do serviço */
        if (searchFilter.afinidades.length > 0) {
            params += '&tbservico.idafinidade=_in_' + searchFilter.afinidades.map(afinidade => afinidade.id);
        }

        /* consulta pela cidade do serviço */
        if (!(searchFilter.codcidadeservico === '')) {
            params += '&tbservico.codcidadeservico=' + searchFilter.codcidadeservico
        }

        /* consulta somente serviços vendidos no PDV Móvel */
        if (searchFilter.somenteServPDVMovel === true) {
            params += '&tbservico.atualizainfpdvmovel=' + ASIM
        }

        /* filtra por pdvs do serviço */
        if (multipdv) {
            if (searchFilter.pdvs.length > 0) {
                params += '&pdvs=' + searchFilter.pdvs.map(pdv => pdv.id)
            }
        }

        params += '&sort=descservico';

        const response = await api.get('/servico' + params);
        this.setState({
            servicos: response.data.data,
            totalItems: parseInt(response.data.info['totalrecords'], 10) || 0
        });
    }

    /* Escolha de uma conta para exclusão */
    handleSelectItem = (id) => {
        this.setState({ selectedId: id });
    };

    /* deleta serviço */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/servico/${id}`);
            // Verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadServicos();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
            console.log(error);
            console.log(error.message);
        }
    };

    /* abre janela confirmação para exclusão */
    handleOpen = (codservico) => {
        this.setState({ open: true });
        this.handleSelectItem(codservico);
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { searchFilter } = this.state;
        let { name, value } = event.target;
        value = value.toUpperCase()
        searchFilter[name] = value;

        if (event.target.name === 'somenteServPDVMovel') {
            searchFilter['somenteServPDVMovel'] = event.target.checked;
        }

        this.setState({ searchFilter: searchFilter });
        if (name === 'situacaoInativoFilter') {
            this.loadServicos();
        }
    };

    // Função que será passada como prop para o CitySearch
    handleCitySelection = (city) => {
        let { searchFilter } = this.state;
        searchFilter.codcidadeservico = city.codcidade;
        this.setState({ searchFilter: searchFilter });
    };

    /* Limpa Filtros na tela */
    LimpaFiltros = () => {
        let {
            searchFilter,
            listaGeneroReceptivo,
            listaGeneroAgencia,
            listaPdvs
        } = this.state;

        searchFilter.nomeServico = '';
        searchFilter.abreviatura = '';
        searchFilter.codServico = '';
        searchFilter.situacaoInativoFilter = 'N';
        searchFilter.generosReceptivo = listaGeneroReceptivo;
        searchFilter.generosAgencia = listaGeneroAgencia;
        searchFilter.afinidades = [];
        searchFilter.codcidadeservico = '';
        searchFilter.somenteServPDVMovel = false;

        const codPDV = sessionStorage.getItem('codPDV');
        searchFilter.pdvs = listaPdvs.filter(item => item.id == codPDV);

        this.setState({ searchFilter: searchFilter });
    }

    OnChangeGenerosReceptivo = (newList) => {
        let { searchFilter } = this.state;
        searchFilter.generosReceptivo = newList;
        this.setState({ searchFilter: searchFilter });
    };

    OnChangeGenerosAgencia = (newList) => {
        let { searchFilter } = this.state;
        searchFilter.generosAgencia = newList;
        this.setState({ searchFilter: searchFilter });
    };

    OnChangeAfinidades = (newList) => {
        let { searchFilter } = this.state;
        searchFilter.afinidades = newList;
        this.setState({ searchFilter: searchFilter });
    };

    OnChangePdvs = (newList) => {
        let { searchFilter } = this.state;
        searchFilter.pdvs = newList;
        this.setState({ searchFilter: searchFilter });
    };

    handleSearch = () => {
        let errors = this.validationRequiredFields();

        if (!(errors === '')) {
            this.handleOpenAlert(errors);
        } else {
            this.loadServicos();
        }
    };

    validationRequiredFields = () => {
        const { searchFilter } = this.state;
        const multipdv = (getConfigField('formapdv') == AFORMA_PDV_SISARE_MULTI);
        let errors = '';

        if ((searchFilter.generosReceptivo.length === 0) && (searchFilter.generosAgencia.length === 0)) {
            errors = 'Marque pelo menos um gênero de serviço para pesquisa'
        } else if ((multipdv) && (searchFilter.pdvs.length === 0)) {
            errors = 'Marque pelo menos um ponto de venda para pesquisa'
        }

        return errors;
    };

    /* Mudança de página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.loadServicos();
        });
    };

    /* Mudança na quantidade de linhas por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => {
            this.loadServicos();
        });
    };


    render() {
        const { servicos, searchFilter, page, rowsPerPage, totalItems } = this.state;
        const { listaGeneroReceptivo, listaGeneroAgencia, listaAfinidades, listaPdvs } = this.state;

        // dados empresa
        const empresa = loadCompany();

        // campos configurações
        const multipdv = (getConfigField('formapdv') == AFORMA_PDV_SISARE_MULTI);

        return (
            <div style={this.estilo} >
                <Button
                    component={Link}
                    to="/front/servicos/novo"
                    variant="contained"
                    color="primary"
                    style={this.estilo.addButton}
                >
                    Novo
                </Button>

                <Paper
                    hover
                    size
                    style={{ marginBottom: 10, marginTop: 10 }}

                >
                    <Input
                        autoFocus
                        id="nomeServico"
                        name="nomeServico"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Nome serviço a pesquisar"
                        style={{ marginBottom: 10, width: 300, marginLeft: 10, marginTop: 10 }}
                        value={searchFilter.nomeServico}
                    />

                    <Input
                        id="abreviatura"
                        name="abreviatura"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Abreviatura"
                        style={{ marginBottom: 10, width: 150, marginLeft: 15, marginTop: 10 }}
                        value={searchFilter.abreviatura}
                    />

                    <Input
                        id="codServico"
                        name="codServico"
                        onChange={this.OnChangeSearch}
                        onBlur={this.onInputBlur}
                        placeholder="Código"
                        style={{ marginTop: 15, marginLeft: 15, marginBottom: 10, width: 100 }}
                        value={this.state.searchFilter.codServico}
                        type="number"
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.OnChangeSearch}
                        style={{ marginLeft: 20 }}
                    >
                        <MenuItem value={ANAO}>Ativos</MenuItem>
                        <MenuItem value={ASIM}>Inativos</MenuItem>
                        <MenuItem value={'T'}>Todos</MenuItem>
                    </Select>

                    <Button
                        color="primary"
                        id="pesquisar"
                        onClick={this.handleSearch}
                    >
                        <SearchIcon />
                    </Button>

                    <Button
                        color="primary"
                        onClick={() => this.LimpaFiltros()}
                    >
                        <ClearAllIcon />
                    </Button>
                </Paper>

                <Paper
                    hover
                    size
                    style={{ marginBottom: 10, marginTop: 10, paddingBottom: 10, paddingTop: 5 }}
                >
                    <FormGroup row>
                        <Box
                            style={{ marginLeft: 10, width: 220 }}
                        >
                            <ComboPadraoMultiple
                                options={searchFilter.generosReceptivo}
                                label={(listaGeneroAgencia.length > 0) ? "Receptivo" : "Gênero do serviço"}
                                itens={listaGeneroReceptivo}
                                onSelectionChange={this.OnChangeGenerosReceptivo}
                            />
                        </Box>

                        {(listaGeneroAgencia.length > 0) && (<Box
                            style={{ marginLeft: 10, width: 220 }}
                        >
                            <ComboPadraoMultiple
                                options={searchFilter.generosAgencia}
                                label="Agência de viagens"
                                itens={listaGeneroAgencia}
                                onSelectionChange={this.OnChangeGenerosAgencia}
                            />
                        </Box>)}

                        <Box
                            style={{ marginLeft: 10, width: 220 }}
                        >
                            <ComboPadraoMultiple
                                options={searchFilter.afinidades}
                                label="Afinidades"
                                itens={listaAfinidades}
                                onSelectionChange={this.OnChangeAfinidades}
                            />
                        </Box>
                    </FormGroup>
                </Paper>

                <Paper
                    hover
                    size
                    style={{ marginBottom: 10, marginTop: 10 }}
                >
                    <FormGroup row>
                        <Box style={{ marginBottom: 10, marginLeft: 10, marginRight: 10, marginTop: 10, width: 300 }}>
                            <SearchCidade
                                label=""
                                placeholder="Cidade"
                                onCitySelect={this.handleCitySelection}
                            />
                        </Box>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={searchFilter.somenteServPDVMovel}
                                    name="somenteServPDVMovel"
                                    onChange={this.OnChangeSearch}
                                    color="primary"
                                />}
                            label={'Filtrar somente serviços vendidos no PDV Móvel'}
                            style={{
                                display: ((!(empresa && empresa.modulopdvmovel && empresa.modulovendatablet === ANAO)) ? '' : 'none'),
                                marginLeft: 5,
                                marginTop: 5
                            }}
                        />
                    </FormGroup>
                </Paper>

                <Paper
                    hover
                    size
                    style={{ marginBottom: 10, marginTop: 10, paddingBottom: 10, paddingTop: 5 }}
                >
                    {multipdv && (
                        <Box
                            style={{ marginLeft: 10, width: 220 }}
                        >
                            <ComboPadraoMultiple
                                options={searchFilter.pdvs}
                                label="Pontos de venda"
                                itens={listaPdvs}
                                onSelectionChange={this.OnChangePdvs}
                            />
                        </Box>

                    )}
                </Paper>

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Descrição</TableCell>
                                            <TableCell>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {servicos.slice(0, 1000).map(servico => (
                                            <TableRow
                                                hover
                                                key={servico.codservico}
                                            >
                                                <TableCell style={(servico.inativo === ASIM) ? this.estilo.redText : {}}>{servico.codservico}</TableCell>

                                                <TableCell style={(servico.inativo === ASIM) ? this.estilo.redText : {}} >{servico.descservico}</TableCell>

                                                <TableCell>
                                                    <Link to={`/front/servicos/${servico.codservico}`}>
                                                        <EditOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <Link to={`/front/servicos/${servico.codservico}/view`}>
                                                        <PageviewOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={() => this.handleOpen(servico.codservico)}
                                                        style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>
                <TablePagination
                    component="div"
                    labelRowsPerPage={'Registros por página'}
                    rowsPerPageOptions={[50, 100, 150]}
                    count={totalItems}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                    }
                />

                <DeleteConfirmationModal
                    open={this.state.open}
                    handleClose={() => this.handleClose()}
                    itemId={this.state.selectedId}
                    message={"Confirma exclusão do serviço " + this.state.selectedId + '?'}
                    handleDelete={() => this.handleDelete(this.state.selectedId)}
                />

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

export default ServicoList;